import { useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  useGetAllFeedbacksQuery,
  useGetFeedbackCategoriesQuery,
} from "../../../redux/slices/feedbackApiSlice";
import { FeedbackCard, FeedbackForm, FeedbackLogin } from "../feedbacks";
import { CustomLoader } from "../../../components";

const FeedbackList = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [newFeedback, setNewFeedback] = useState({
    type: "",
    title: "",
    text: "",
    is_internal: false,
    status: "suggested",
  });
  const userInfo = useSelector((state) => state?.auth.userInfo);

  // Fetch categories from API
  const { data: categories = [], isLoading: categoriesLoading } =
    useGetFeedbackCategoriesQuery();

  // Fetch all feedbacks from API
  const { data: feedbacks = [], isLoading: feedbacksLoading } =
    useGetAllFeedbacksQuery({});

  const categoryKey = searchParams.get("category");
  const category =
    categories.find((cat) => cat.key === categoryKey) || categories[0];

  // Filter feedbacks based on selected category
  const filteredFeedbacks = feedbacks
    .filter((fb) => fb.category === category?.key)
    .sort((a, b) => b.likes - a.likes || b.id - a.id);

  if (categoriesLoading || feedbacksLoading)
    return (
      <div className="flex justify-center">
        <CustomLoader />
      </div>
    );

  return (
    <div className="flex gap-6 p-6 h-[calc(100vh-120px)]">
      {/* Sidebar catégories */}
      <div className="flex flex-col w-1/3 gap-2 rounded-lg sticky top-0 self-start">
        {/* Back to feedbacks main page link */}
        <div
          className="flex items-center gap-2 text-blue-500 cursor-pointer hover:underline mb-4"
          onClick={() => navigate("/feedbacks")}
        >
          <IoMdArrowBack size={18} />
          <span>Retourner à la page de feedbacks</span>
        </div>

        {categories.map((cat) => (
          <div
            key={cat.key}
            className={`flex justify-between items-center border border-black/30 p-4 rounded-lg cursor-pointer ${
              category?.key === cat.key
                ? "bg-black/10"
                : "bg-white hover:bg-black/5"
            }`}
            onClick={() => navigate(`/feedbacks/list?category=${cat.key}`)}
          >
            <span className="font-semibold">{cat.name}</span>
            <span className="bg-gray-300 text-gray-700 px-3 py-1 rounded-full">
              {cat.count}
            </span>
          </div>
        ))}
      </div>

      {/* Contenu principal */}
      <div className="w-2/3 overflow-y-auto h-[calc(100vh-130px)]">
        <h1 className="mb-2 text-2xl">{category?.name || "Feedbacks"}</h1>

        {/* Formulaire */}
        {userInfo ? (
          <FeedbackForm
            feedbackData={newFeedback}
            setFeedbackData={setNewFeedback}
            btnText={"Publier le feedback"}
            category={category?.key}
          />
        ) : (
          <FeedbackLogin />
        )}

        {/* Liste des feedbacks */}
        {filteredFeedbacks.map((fb) => (
          <FeedbackCard key={fb.id} feedback={fb} isLong={true} />
        ))}
      </div>
    </div>
  );
};

export default FeedbackList;
